import React from "react";
import { Navigate } from "react-router-dom";

const FreeDetail = () => {
  return <Navigate to="/free" replace />;
};

export default FreeDetail;
